import { AppActions } from '@/app/app.keys';
import { NotificationsListingActions } from '@/app/features/notifications/features/notifications-listing/notifications-listing.keys';
import { STATE_RESET_ACTION_PREFIX } from '@/app/app.keys';
const parseJwt = token => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

export const sessionUtils = {
  methods: {
    setAccessTokenAndRedirectToHome(response) {
      localStorage.setItem('tol-token', response.data.accessToken);
      localStorage.setItem('tol-refresh-token', response.data.refreshToken);
      const tokenData = parseJwt(response.data.accessToken);
      const FIVE_MINUTES_BEFORE_EXPIRY =
        (tokenData.exp - Math.floor(Date.now() / 1000) - 300) * 1000;

      this.$store.dispatch(AppActions.SetRefreshTokenModalIsVisible, false);
      //called five minutes before session is about to expire
      //replace existing token with new token which has updated expiry date
      this.$store.dispatch(
        AppActions.InsertTimeOutReferences,
        setTimeout(() => {
          this.$store.dispatch(AppActions.SetRefreshTokenModalIsVisible, true);
        }, FIVE_MINUTES_BEFORE_EXPIRY)
      );
      this.$store.dispatch(AppActions.SetSessionRefreshTime, FIVE_MINUTES_BEFORE_EXPIRY);
      this.$store.dispatch(AppActions.SetAccountVerificationRequired, {
        required: false,
        username: '',
        userFirstname: ''
      });
      this.resetStore();
      this.$store.dispatch(NotificationsListingActions.RetrieveNotifications);
      this.$router.push(this.$store.state.redirectTo || '/');
      this.resetTimer();
      this.inactivityTime();
    },
    inactivityTime() {
      window.onload = this.resetTimer;
      document.onmousemove = this.resetTimer;
      document.onkeydown = this.resetTimer;
    },
    resetTimer() {
      this.$store.dispatch(AppActions.UpdateLastActiveTime);
    },
    resetStore() {
      if (this.$store) {
        for (let key of Object.keys(this.$store.state)) {
          if (key.includes('State')) {
            key = key[0].toUpperCase() + key.slice(1);
            const actionName = STATE_RESET_ACTION_PREFIX + key;
            if (this.$store._actions[actionName]) {
              this.$store._actions[actionName][0]();
            }
          }
        }
      }
    }
  }
};
